import { useEffect, useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";

const Tab2 = ({ vendor_address, shippingAddr }) => {
  const [editableVendorAddress, setEditableVendorAddress] = useState({});

  
  useEffect(() => {
    if (vendor_address.currentAddress) {
      setEditableVendorAddress(vendor_address.currentAddress);
    }
  }, [vendor_address.currentAddress]);



  return (
    <div className="row m-0" style={{ padding: "8px", borderRadius: "5px" }}>
      <div className="col-12">
        <div className="tableLabel">
          <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>
            Supplier Address
          </p>
          <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
        </div>
      </div>

      

      {["address_line1", "address_line2", "city", "state", "country", "pincode", "phone"].map((field, idx) => (
        <div className="col-md-4 mt-0" key={idx}>
          <div className="mb-3">
          <Input id="orderNo" label={field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())} readOnly value={editableVendorAddress[field] || ""} style={{ height: '30px' }} />

          </div>
        </div>
      ))}

      <div className="col-12 mt-3">
        <div className="tableLabel">
          <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>
            Shipping Address
          </p>
          <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
        </div>
      </div>

      <div className="col-md-4 mt-0">
        <div className="mb-3">
          <Input id="orderNo" label="Shipping Address" readOnly value={shippingAddr.currentAddress || ""} style={{ height: '30px' }} />

        </div>
      </div>
    </div>
  );
};

export default Tab2;
